import { getPageInfoInitActions, getCommonSectionInitActions } from './common';

export function getAdoptabobblesSectionInitActions(
  responseData,
  requestParams
) {
  return [
    ...getPageInfoInitActions(responseData, requestParams),
    ...getCommonSectionInitActions(
      responseData,
      requestParams,
      'adoptabobbles'
    ),
  ].filter(action => action);
}
